<app-menu-bar></app-menu-bar>
<div class="processamento-container">
    <div style="text-align: center">Processamento dos Documentos</div>
       
    <div class="table-container">
        <p-table
        [value]="processamentos"
        styleClass="carga-table"
        [tableStyle]="{ 'min-width': '64rem' }"
        [paginator]="true"
        [rows]="20"
        [rowsPerPageOptions]="[10, 20, 50, 100]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first}-{last} de {totalRecords}"
        [globalFilterFields]="[
          'dados.id',
          'dados.processamentoLista.id',
          'dados.empresa',
          'dados.estabelecimento',
          'dados.codigoReferenciaIntegracao',
          'dados.sequenciaItem',
          'dados.etapa',
          'dados.statusProcessamento',
          'dados.mensagemAviso',
          'dados.valorAuxiliar', ]">


            <ng-template pTemplate="header">
                <tr>
                    <th class="carga-col-hide-sm" pSortableColumn="id">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Id
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="id"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="id"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>
            
                      <th pSortableColumn="processamentoLista.id">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Processamento Lista
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="processamentoLista.id"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="processamentoLista.id"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="empresa">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Empresa
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="empresa"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="empresa"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="estabelecimento">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Estabelecimento
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="estabelecimento"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="estabelecimento"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="codigoReferenciaIntegracao">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Código Integração
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="codigoReferenciaIntegracao"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="codigoReferenciaIntegracao"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="sequenciaItem">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Sequencia Item
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="sequenciaItem"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="sequenciaItem"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>                      

                      <th pSortableColumn="etapa">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Etapa
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="etapa"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="etapa"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="statusProcessamento">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Status
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="statusProcessamento"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="statusProcessamento"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="mensagemAviso">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Mensagem de Aviso
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="mensagemAviso"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="mensagemAviso"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="valorAuxiliar">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Valor Auxiliar
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="valorAuxiliar"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="valorAuxiliar"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                </tr>
                
            </ng-template>
            <ng-template pTemplate="body" let-dados>
                <tr>  
                    <td class="carga-col-hide-sm">{{ dados.id }}</td>
                    <td>{{ dados.processamentoLista.nomeLista }}</td> 
                    <td>{{ dados.empresa }}</td>
                    <td>{{ dados.estabelecimento}}</td>
                    <td>{{ dados.codigoReferenciaIntegracao }}</td>
                    <td>{{ dados.sequenciaItem }}</td>
                    <td>{{ dados.etapa }}</td>
                    <td>
                        <span class="carga-status">
                            <i [class]="getIconClass(dados.statusProcessamento)"></i>
                            <span class="carga-badge" [ngClass]="'carga-badge--' + (dados.statusProcessamento | statusBadge)">{{ dados.statusProcessamento }}</span>
                        </span>
                    </td>
                    <td>{{ dados.mensagemAviso }}</td>
                    <td>{{ dados.valorAuxiliar }}</td>

                </tr>
        
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td class="carga-empty" colspan="10">
                        <div class="carga-empty__content">
                            <i class="pi pi-inbox"></i>
                            <span>Nenhum registro encontrado</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </div>

